import { ActivatedRouteSnapshot, Params } from '@angular/router';

const getRouteData = (route: ActivatedRouteSnapshot, data: Params) => {
  const newData = { ...data, ...route.data };
  if (!route.firstChild) return newData;
  return getRouteData(route.firstChild, newData);
};

export const getAllRouteData = (route: ActivatedRouteSnapshot): Params => {
  return getRouteData(route.root, {});
};

export const getAllRouteDatas = (route: ActivatedRouteSnapshot): Params[] => {
  const datas: Params[] = [];
  let currentRoute: ActivatedRouteSnapshot | null = route.root;

  while (currentRoute) {
    datas.push(currentRoute.data);
    currentRoute = currentRoute.firstChild;
  }

  return datas;
};
